import Pagination from './pagination';

export default class DatesTable {

  constructor(container) {
    this.container = container;
    this.paginationContainer = $(this).find('#dates-pagination');
    this.init();
  }

  init() {
    this.addEventlisteners();
    let filterBy = $('input[name="dates_filter_by"]').val();

    var that = this;
    this.pagination = new Pagination({
      container : that.paginationContainer,
      page : 1,
      postType : 'date',
      postsPerPage : ajax_args.dates_per_page,
      taxonomies: {
        datetype: filterBy,
      },
      beforeLoad : function() {
        that.setLoading(true);
      },
      onUpdate : function(response) {
        $('#dates-table').html(response['dates']);
        that.addEventlisteners();
        that.setLoading(false);
      },
    });
  }

  addEventlisteners() {
    // Dates table details toggle
    $('.c-dates-table__row--has-details').click(function() {
      $(this).toggleClass('c-dates-table__row--is-open');
    });
  }

  setLoading(active) {
    let loadingClass = 'c-dates-table--loading';
    if (active) {
      $(this.container).addClass(loadingClass);
    } else {
      $(this.container).removeClass(loadingClass);
    }
  }
}



// WEBPACK FOOTER //
// ./scripts/components/dates-table.js